exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topbar h2{margin-left:3px;margin-right:10px;margin-bottom:0;display:inline-block}.grid.detailed{border-spacing:0 10px}.grid.detailed th{width:25%}.grid.detailed th h3{margin-top:0}.grid.detailed .bar.horse .tasks{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c115f10","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Board/Grids/DetailedView.vue
// module id = 652
// module chunks = 0